import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Locale {
  lang: string;
  data: Object;
}

@Injectable({
  providedIn: 'root',
})
export class TranslationLoaderService {
  constructor(private translate: TranslateService) {}

  public loadTranslations(...args: Locale[]): void {
    const locales = [...args];
    locales.forEach(locale => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      // console.log('load Translations function called');
      this.translate.setTranslation(locale.lang, locale.data, true);
    });
    // this.translate.setDefaultLang("");
    // this.translate.use();
  }

  setDefaultLanguage(locale: string = 'en'): void {
    this.translate.setDefaultLang(locale);
    this.translate.use(locale);
  }

  getTranslateInstance() {
    return this.translate;
  }
}
